import {
  CATEGORY_RANKING_STAGE,
  type CategoryRankingStage,
} from '@/api/category-ranking/types';
import { z } from 'zod';

import { Gender } from './registerSchema';

export const importConfigSchema = z.object({
  sport: z.string().min(1, { message: 'Elegí un deporte' }),
  tournamentName: z
    .string()
    .trim()
    .min(1, { message: 'El nombre del torneo es requerido' })
    .max(120, { message: 'El nombre es demasiado largo' }),
  earnedAt: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, { message: 'Elegí la fecha de los puntos' }),
});

export type ImportConfigInput = z.infer<typeof importConfigSchema>;

// Typed as a non-empty tuple of the union (not of plain strings) so z.enum keeps inferring
// CategoryRankingStage instead of widening the parsed value to string.
const STAGE_VALUES = Object.values(CATEGORY_RANKING_STAGE) as [
  CategoryRankingStage,
  ...CategoryRankingStage[],
];

/**
 * One editable grid row. name/gender/birthdate are only required when the email has no GetMatch
 * account, and the frontend cannot know that — the backend's dry-run reports the missing ones
 * per row, so here they stay optional.
 */
export const importRowSchema = z.object({
  email: z.string().trim().email({ message: 'Email inválido' }),
  name: z
    .string()
    .trim()
    .max(100, { message: 'Nombre demasiado largo' })
    .optional(),
  gender: z.nativeEnum(Gender).optional(),
  birthdate: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, { message: 'Fecha de nacimiento inválida' })
    .optional(),
  // required_error covers the empty cell: invalid_type_error alone would not fire on undefined.
  categoryId: z
    .number({
      required_error: 'Elegí una categoría',
      invalid_type_error: 'Elegí una categoría',
    })
    .int()
    .positive({ message: 'Elegí una categoría' }),
  stage: z.enum(STAGE_VALUES, {
    errorMap: () => ({ message: 'Elegí una instancia' }),
  }),
});

export type ImportRowInput = z.infer<typeof importRowSchema>;
